import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
    state: () => ({
        sidebarOpen: true,
        wallet: {},
        walletId: 0,
        issuingInstitution: '',
        userSettings: {
            is_admin: false,
            show_last_four: false,
            features: {},
            companion_pass_enabled: false,
            email: '',
            name: '',
            email_verified: false,
            uuid: null,
            show_csp_popup: false,
        },
        version: '',
        onboarded: true,
        phone: null,
        previousRoute: null,
        showAffiliateModal: false,
        showNextCardMethodModal: false,
        breadcrumbs: {},
    }),
    getters: {
        showCspPopup(state) {
            return state.userSettings.show_csp_popup;
        },
    },
    actions: {
        setPreviousRoute(route) {
            this.previousRoute = route;
        },
        setSidebarOpen(data) {
            this.sidebarOpen = data;
        },
        setWallet(data) {
            this.wallet = data;
        },
        setWalletId(data) {
            this.walletId = data;
        },
        setAppWalletId(data) {
            this.walletId = data;
        },
        setInstitution(data) {
            ApiService.apiCall(
                '/admin/institution-by-issuing-bank-id/' + data,
                'get'
            )
                .then((response) => {
                    this.issuingInstitution = response.data.institution_code;
                })
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                });
        },
        setUserSettings(data) {
            this.userSettings = data;
        },
        setVersion(data) {
            this.version = data;
        },
        setOnboarded(data) {
            this.onboarded = data;
        },
        setPhone(data) {
            this.phone = data;
        },
        setShowAffiliateModal(set) {
            this.showAffiliateModal = set;
        },
        setShowNextCardMethodModal(set) {
            this.showNextCardMethodModal = set;
        },
        setShowLastFour(val) {
            this.userSettings.show_last_four = val;
            ApiService.apiCall('/user/setting', 'put', {
                setting: 'show_last_four',
                value: val,
            })
                .then((response) => {})
                .catch((response) => {});
        },
        setBreadcrumbs(key, val) {
            this.breadcrumbs[key] = val;
        },
    },
});
